/** Inline validation message under auth form fields. */
export default function AuthFormFieldMessage({ message, tone = "error" }) {
  if (!message) return null;

  const toneClass =
    tone === "warning"
      ? "text-amber-300"
      : tone === "success"
        ? "text-emerald-400"
        : "text-red-400";

  return (
    <p className={`text-[11px] mt-1 ${toneClass}`} role="alert" aria-live="polite">
      {message}
    </p>
  );
}
